module.exports = __webpack_public_path__ + "img/colorscale.a4b8d048.png";